import * as React from "react";
import {useState} from "react";
import {Business, BusinessLocation} from "../../types/Types";
import {useEffect} from "react";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";
import {Col, Form} from "react-bootstrap";

interface Props {
  business: Business | undefined,
  setValue: (valueToSet: string) => void,
}

function LocationSelector(props: Props) {
  const [locations, setLocations] = useState<Array<BusinessLocation>>([]);

  useEffect(() => {(async () => {
    if(!props.business || props.business.locations.length === 0) {
      return
    }
    let locations = new Array<BusinessLocation>();
    const locationsCollection = query(
        collection(db, 'locations'),
        where("id", "==", props.business.locations[0]),
        orderBy("createdAt", "desc"),
        limit(200),
    );
    const locationsSnapshot = await getDocs(locationsCollection);
    locationsSnapshot.forEach((doc) => {
      locations.push(doc.data() as BusinessLocation);
    });
    setLocations(locations);
    props.setValue(locations[0].id);
  })();
  }, []);

  const location = locations[0];

  return (
      <>
        {location && <div className="form-row">
            <Col>
                <Form.Group className="form-element" controlId="location">
                    <Form.Label><small><b>Location <span className={"font-red"}>*</span></b></small></Form.Label>
                    <Form.Select
                        as="select"
                        name={"location"}
                        value=""
                        required
                        disabled
                    >
                        <option>{location.address}</option>
                    </Form.Select>
                </Form.Group>
            </Col>
        </div>}
      </>
  )
}

export default LocationSelector;